// Imports
import styled from "styled-components"
import { Variables, Font } from "fajny-react"

const Container = styled(Font.P)`
    background-color: ${Variables.Colors.Primary500};
    color: ${Variables.Colors.White};
    padding: ${Variables.Spacers.XS};
`

export { Container }
